/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `EMISSIONS` - Emissions
 * * `INFRASTRUCTURE` - Infrastructure
 * * `SCENES` - Scenes
 * * `EPA_SEP` - Epa Sep
 * * `NON_DETECTS` - Non Detects
 * * `EXTRA_DATA` - Extra Data
 * @export
 */
export const ImportTypeEnum = {
    Emissions: 'EMISSIONS',
    Infrastructure: 'INFRASTRUCTURE',
    Scenes: 'SCENES',
    EpaSep: 'EPA_SEP',
    NonDetects: 'NON_DETECTS',
    ExtraData: 'EXTRA_DATA'
} as const;
export type ImportTypeEnum = typeof ImportTypeEnum[keyof typeof ImportTypeEnum];


export function instanceOfImportTypeEnum(value: any): boolean {
    for (const key in ImportTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(ImportTypeEnum, key)) {
            if (ImportTypeEnum[key as keyof typeof ImportTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportTypeEnumFromJSON(json: any): ImportTypeEnum {
    return ImportTypeEnumFromJSONTyped(json, false);
}

export function ImportTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTypeEnum {
    return json as ImportTypeEnum;
}

export function ImportTypeEnumToJSON(value?: ImportTypeEnum | null): any {
    return value as any;
}

export function ImportTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportTypeEnum {
    return value as ImportTypeEnum;
}

